// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"top-title-block-component_titleContainer__2S5WF","title":"top-title-block-component_title__1_J-p","description":"top-title-block-component_description__3gSVw"};